module.exports = __webpack_public_path__ + "media/images/smart_phone/item/btn_confirm_ov-41c01e22e6262bfc58704c0f67a95e63.png";